module.exports = __webpack_public_path__ + "images/tag-67090daa.svg";